import { crop as cloudinaryCrop, scale } from '@cloudinary/url-gen/actions/resize'

import { MediaCrop } from 'types/media'

export const avatarDimension = 400
export const upspaceCoverDimension = 500

const imageTransformationString = (width: number) => `w_${width},f_auto,q_auto`
const videoTransformationString = `q_auto:good,f_auto`
const posterTransformationString = (width: number) => `w_${width},q_auto:good,f_jpg,so_0`

export const getCropString = (crop: MediaCrop) =>
  cloudinaryCrop(crop.width, crop.height).x(crop.x).y(crop.y).toString()

export const getScaleString = (width: number, height: number) => scale(width, height).toString()

const isCloudinaryUrl = (url: string) => {
  return url.includes('cloudinary.com')
}

export const getTransformedMedia = (
  mediaType: 'image' | 'video' | 'poster',
  url: string,
  width: number,
): string => {
  if (!url || typeof url !== 'string') return ''

  if (!isCloudinaryUrl(url)) {
    return url
  }

  const transformationString =
    // eslint-disable-next-line no-nested-ternary
    mediaType === 'image'
      ? imageTransformationString(width)
      : mediaType === 'video'
      ? videoTransformationString
      : posterTransformationString(width)

  const uploadString = 'upload/'
  const urlPieces = url.split(uploadString)
  if (urlPieces.length >= 2) {
    return `${urlPieces[0]}${uploadString}${transformationString}/${urlPieces[1]}`
  }

  return url
}

export const getTransformedVideoPoster = () => {}
